import { Controller } from 'stimulus';

export default class AnchorMenuController extends Controller {
  static targets = ['link'];

  currentTarget = null;

  connect() {
    document.addEventListener('scroll', this.onScroll);
    this.linkTargets.forEach((link) => {
      link.addEventListener('click', this.onClick);
    });
  }

  disconnect() {
    document.removeEventListener('scroll', this.onScroll);
    this.linkTargets.forEach((link) => {
      link.removeEventListener('click', this.onClick);
    });
  }

  onScroll = () => {
    if (!this.currentTarget) {
      return;
    }

    if (window.pageYOffset === this.currentTarget) {
      this.currentTarget = null;
    }
  };

  onClick = (event) => {
    event.preventDefault();
    const active = this.element.querySelector('.active');

    if (active === event.target && active.dataset.menuType !== 'select') {
      return;
    }

    const target = document.getElementById(event.target.getAttribute('href').replace('#', ''));
    if (!target) {
      return;
    }

    this.currentTarget = window.pageYOffset + target.getBoundingClientRect().top;

    window.scrollTo({
      top: this.currentTarget,
      left: window.pageXOffset,
      behavior: 'smooth',
    });
  };
}
